const DIRECTIONS = {
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical",
};

export { DIRECTIONS };
